import React from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import ListingPageComponent from '../../components/ListingPageComponent';

const Index = () => {
  const defaultHeaderConfig = { disableSort: false };
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'From',
      value: (row) => {
        return <div>
          {row.from_user.name} {(row.form_user?.id_nomenclature)}
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'To',
      value: (row) => {
        return <div>
          {row.to_user.name}
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Type (Credit/Debit)',
      attr: 'credit_or_debit',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Transaction Type',
      attr: 'transaction_type',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Reference ID',
      attr: 'reference_id',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'transaction_created_at',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Updated At',
      attr: 'transaction_updated_at',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'GL Amount',
      attr: 'charge',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'GL Group',
      value: (row) => {
        return <div>
          {row.gl_code.gl_group.name}
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'GL Code',
      value: (row) => {
        return <div>
          {row.gl_code.code}
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Description',
      attr: 'description',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Remarks',
      attr: 'remark',
      disableSort: true
    },
  ]

  return <ListingPageComponent
    key={PAGES.VoltUpAllocationKitTransactionsListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.VoltUpAllocationKitTransactionsListingPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'VAK Transactions'}]}
    listingMutation={getApi('vakTransactions')}
    recordsKey="glk_transactions"
    className="vak-transactions-listing-page"
    contentHeading="VAK Transactions List - Results"
    headers={headers}
    searchBy={['ID', 'Transaction Type']}
  />
};

export default Index;
